import React, { useState } from 'react';
import cls from 'classnames';

import { IconComp } from '../IconComponent';

import { ReactComponent as AlertTriangle } from '../../../assets/svg/icons/alert-triangle.svg';
import { ReactComponent as CheckCircle } from '../../../assets/svg/icons/check-circle.svg';
import { ReactComponent as AlertCircle } from '../../../assets/svg/icons/alert-circle.svg';
import { ReactComponent as InfoCircle } from '../../../assets/svg/icons/info-circle.svg';
import { ReactComponent as XClose } from '../../../assets/svg/icons/x-close.svg';

export enum AlertColor {
  GOLD = 'gold',
  KIWI = 'kiwi',
  STRAWBERRY = 'strawberry',
  GRAPE = 'grape',
}

export interface IAlertProps {
  color: AlertColor;
  description?: string;
  title?: string;
  icon?: React.ReactType;
  className?: string;
  onAlertClose?: () => void;
}

export const AlertComp: React.FC<IAlertProps> = (props) => {
  const { color, description, title, icon, className, onAlertClose } = props;

  const [isClosed, setIsClosed] = useState<boolean>(false);

  const iconMapper = {
    gold: AlertTriangle,
    kiwi: CheckCircle,
    strawberry: AlertCircle,
    grape: InfoCircle,
  };

  return (
    <div
      className={cls(
        '',
        {
          'bg-gold-300': color === AlertColor.GOLD,
          'bg-kiwi-300': color === AlertColor.KIWI,
          'bg-strawberry-300': color === AlertColor.STRAWBERRY,
          'bg-grape-300': color === AlertColor.GRAPE,
          hidden: isClosed,
        },
        className,
      )}
    >
      <div className={cls('relative app-container mx-auto flex flex-col px-4 py-3 relative')}>
        <p className="relative text-sm font-bold">
          <IconComp
            className={cls({
              'absolute top-0 -left-3': title,
              'absolute -top-0.5 -left-3': !title,
            })}
            icon={icon ? icon : iconMapper[color]}
            size={16}
          />
          {title}
        </p>
        <p
          className={cls('text-base text-cloud-900 tracking-wide', {
            'absolute top-2.5': !title,
            'mt-0.5': title,
          })}
        >
          {description}
        </p>
        <button
          onClick={(): void => {
            setIsClosed(true);
            onAlertClose && onAlertClose();
          }}
          className="absolute top-3 right-3"
        >
          <IconComp icon={XClose} size={10} className="stroke-current text-cloud-900" />
        </button>
      </div>
    </div>
  );
};
